<template>
    <div>
        <!-- Imprimir Anexos -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Imprimir Anexos</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-danger" v-if="guias && !guias.length">
                            Nenhuma guia selecionada para impressão de anexos.
                        </div>

                        <template v-else>

                            <div class="alert alert-info" v-if="guias && guias.length">
                                {{ guias.length }} guia(s) selecionada(s) para impressão de anexos.
                            </div>

                            <div class="d-flex flex-column mb-2">
                                <az-input 
                                    sizing="sm"
                                    label="Gerar"
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'U', search: 'PDF Único' }, 
                                        { id: 'Z', search: 'ZIP com os Anexos' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="tipo_resultado">
                                </az-input>
                            </div>

                            <az-input
                                v-if="false"
                                label="Tipo"
                                type="select"
                                optionsMode="aql"
                                optionsData="id_tipo_arquivo"
                                optionsDisplay="st_descricao"
                                :optionsName="'tipos_arquivo.index.' + model"
                                service="tipo_arquivos.index"
                                :optionsParm="{ fl_ativo: 1, model: model }"
                                placeholder="Selecionar o tipo de arquivo..."
                                required
                                :validate="validate"
                                v-model="id_tipo_arquivo">
                            </az-input>

                            <ul class="list-group">
                                <li class="list-group-item py-2 d-flex justify-content-between" v-for="(item_tipo, itx) in lista_tipos" :key="itx">
                                    <div>
                                        <input type="checkbox" v-model="item_tipo.selec" class="mr-3" :disabled="!!buscando"/>
                                        {{ item_tipo.search }}
                                    </div>
                                    <div>
                                        <span class="badge badge-light ml-1" v-if="item_tipo.st_sigla">{{ item_tipo.st_sigla }}</span>
                                        <span class="badge badge-secondary ml-1">#{{ item_tipo.id_tipo_arquivo }}</span>
                                    </div>
                                </li>
                            </ul>   

                            <az-loading class="mt-3" v-if="buscando" />

                            <div v-else-if="retorno" class="mt-3">
                                <div class="alert alert-info d-flex justify-content-between">
                                    <div>
                                        <span v-if="retorno.qtde">{{ retorno.qtde }} documento(s) encontrado(s).</span>
                                        <span v-else>Nenhum documento encontrado.</span>
                                    </div>
                                    <div v-if="retorno.url">
                                        <a :href="retorno.url" class="card-link" target="_blank">Abrir/Imprimir</a>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="imprimir()" :disabled="!( guias && guias.length )">Gerar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzLoading from '../../util/AzLoading.vue';

export default {
    data() {
        return { 
            id_tipo_arquivo: "", 
            guias: [], 
            model: 'marcacao', 
            validate: false, 
            retorno: null, 
            buscando: false, 
            modal_name: 'guiaImprimirAnexosModal', 
            tipo_resultado: 'U', 
            lista_tipos: null, 
        };
    },

    components: {
        AzInput,
        AzSubmit,
        AzLoading,
    },

    methods: { 
        abrir(guias) { 
            this.guias = _.cloneDeep(guias);
            this.retorno = null; 
            this.buscando = false;

            if ( this.lista_tipos === null ) { 

                this.$util.loadItem(this, { 
                    service: 'tipo_arquivos', 
                    func: 'index', 
                    parms: { 
                        fl_ativo: 1,
                        model: this.model
                    },
                })
                .then(res => { 
                    this.lista_tipos = res.map(item_tipo => { 
                        item_tipo.selec = false; 
                        return item_tipo;
                    });
                });
                
            }

            $('#' + this.modal_name).modal('show');
        },

        imprimir() {
            let id_tipos = this.lista_tipos.filter(item_tipo => item_tipo.selec)
                .map(item_tipo => item_tipo.id_tipo_arquivo);

            if ( !id_tipos.length ) { 
                
                this.$toast.add({ 
                    severity: 'error',
                    summary: 'Atenção',
                    detail: 'Selecione pelo menos um tipo.',
                    life: 3000, 
                });

                return;

            }

            this.retorno = null; 
            this.buscando = true;

            this.$util.atualizar(this, { 
                service: 'guias', 
                func: 'imprimir_anexos',
                redir_api: true, 
                dados: { 
                    ids: this.guias.map(g => g.id_guia),
                    id_tipos: id_tipos,
                    tipo_resultado: this.tipo_resultado, 
                },
                callback: res => { 
                    this.retorno = res; 
                },
                final: () => { 
                    this.buscando = false;
                }
            });
            
        }

    },

    mounted() { 
        this.modal_name = 'guiaImprimirAnexosModal' + this.$util.uuidv4();
    }

}
</script>
